import React from 'react';
import ConviteEvento from './Conviteevento';
import './App.css';

function App() {
  return (
    <ConviteEvento/>
  );
}

export default App;